/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Page from "components/common_components/Page/Page";
import Form from "./Form";
import { useDispatch } from "react-redux";
import { notifySuccess, notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "../SettingsContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";
import Button from "components/common_components/Button";

const headCells = [
    { index: 1, id: "id", disablePadding: false, label: "Identifier" },
    { index: 2, id: "name", disablePadding: false, label: "Name" },
    { index: 3, id: "unitPrice", disablePadding: false, type: "currency", numeric: true, label: "Unit Price" },
];

function Products(props) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [mode, setMode] = useState("listOnly");
    const [itemToEdit, setItemToEdit] = useState(undefined);
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "name",
        orderDirection: "asc",
        pageNumber: 0,
        pageSize: 5,
    };

    const { Products } = useContext(SettingsContext);

    function getProducts(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Products.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getProducts();

        return () => {
            setData([]);
            setItemToEdit(undefined);
        };
    }, []);

    function onRowClickHandler(item) {
        setItemToEdit(item);
        setMode("update");
    }

    function onCancelHandler() {
        setItemToEdit(undefined);
        setMode("listOnly");
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        onCancelHandler();
        dispatch(notifySuccess(`Service ${mode === "add" ? "created" : "updated"} successfully!`));
        getProducts();
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const apiCall = mode === "add" ? Products.add : Products.update;
        setSubmitting(true);
        apiCall({
            payload: values,
            onSuccess: (response) => onSuccess(response, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getProducts();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Products.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  name: filterValue,
                  id: filterValue,
              }
            : {};
    }

    function onAddHandler() {
        setItemToEdit(undefined);
        setMode("add");
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {mode !== "listOnly" && (
                        <Form
                            data={itemToEdit}
                            onSubmit={onSubmitHandler}
                            onCancel={onCancelHandler}
                            title={mode === "add" ? "New Service" : "Update Service"}
                        />
                    )}
                    {mode === "listOnly" && (
                        <>
                            <Header title="Services">
                                <Button primary onClick={onAddHandler}>
                                    <Icon name="add" size="md" color="white" />
                                    <span>Add</span>
                                </Button>
                            </Header>
                            <div className="layout">
                                <EnhancedTable
                                    headCells={headCells}
                                    data={data}
                                    defaultOrder={{
                                        order: defaultRequestData.orderDirection,
                                        orderBy: defaultRequestData.orderBy,
                                    }}
                                    selectable
                                    keyColumnName="id"
                                    onRowClick={onRowClickHandler}
                                    onDelete={onDeleteHandler}
                                    onRequestData={getProducts}
                                    filterBuilder={filterBuilder}
                                    pageableData={pageableData}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </Page>
    );
}

export default withRouter(Products);
